// import { useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { logout } from "./Store/Slices/AuthSlice";

// const INACTIVITY_TIMEOUT = 30 * 60 * 1000;

// const SessionGuard = ({ children }) => {
//   const dispatch = useDispatch();
//   const inactivityTimerRef = useRef(null);
//   const [showSessionPopup, setShowSessionPopup] = useState(false);

//   const handleSessionExpired = () => {
//     setShowSessionPopup(true);
//   };

//   const handleLogout = () => {
//     dispatch(logout());
//     localStorage.clear();
//     window.location.href = "/";
//   };

//   useEffect(() => {
//     const resetInactivityTimer = () => {
//       clearTimeout(inactivityTimerRef.current);
//       inactivityTimerRef.current = setTimeout(
//         handleSessionExpired,
//         INACTIVITY_TIMEOUT
//       );
//     };

//     const activityEvents = [
//       "click",
//       "keydown",
//       "mousemove",
//       "scroll",
//       "touchstart",
//       "wheel",
//     ];

//     activityEvents.forEach((event) =>
//       document.addEventListener(event, resetInactivityTimer, { passive: true })
//     );

//     resetInactivityTimer();

//     return () => {
//       clearTimeout(inactivityTimerRef.current);
//       activityEvents.forEach((event) =>
//         document.removeEventListener(event, resetInactivityTimer)
//       );
//     };
//   }, []);

//   return (
//     <>
//       {children}

//       {showSessionPopup && (
//         <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
//           <div className="w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl animate-in zoom-in-95 duration-300">

//             {/* Header */}
//             <div className="bg-gradient-to-r from-red-500 to-orange-500 px-6 py-8 text-center">
//               <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white/20 backdrop-blur">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-8 w-8 text-white"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                   strokeWidth={2}
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M12 9v4m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"
//                   />
//                 </svg>
//               </div>

//               <h2 className="mt-4 text-2xl font-bold text-white">
//                 Session Expired
//               </h2>
//             </div>

//             {/* Body */}
//             <div className="px-6 py-6 text-center">
//               <p className="text-gray-600 leading-relaxed">
//                 Your session has expired due to inactivity.
//                 <br />
//                 Please login again to continue.
//               </p>

//               <button
//                 onClick={handleLogout}
//                 className="mt-6 w-full rounded-xl bg-gradient-to-r from-red-500 to-orange-500 px-4 py-3 font-semibold text-white transition-all duration-200 hover:scale-[1.02] hover:shadow-lg"
//               >
//                 Login Again
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default SessionGuard;


// new ui 

import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "./Store/Slices/AuthSlice";
import { logoutFromGateway } from "./CustomHooks/gatewayLogout";
import { ShieldAlert, LogOut, Lock, Sparkles } from "lucide-react";

const INACTIVITY_TIMEOUT = 30 * 60 * 1000;

const SessionGuard = ({ children }) => {
  const dispatch = useDispatch();
  const inactivityTimerRef = useRef(null);
  const [showSessionPopup, setShowSessionPopup] = useState(false);

  const handleSessionExpired = () => {
    setShowSessionPopup(true);
  };

  const handleLogout = async () => {
    await logoutFromGateway();       // frees this login's slot at the gateway (best effort, short wait)
    dispatch(logout());
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimerRef.current);
      inactivityTimerRef.current = setTimeout(
        handleSessionExpired,
        INACTIVITY_TIMEOUT
      );
    };

    const activityEvents = [
      "click",
      "keydown",
      "mousemove",
      "scroll",
      "touchstart",
      "wheel",
    ];

    activityEvents.forEach((event) =>
      document.addEventListener(event, resetInactivityTimer, { passive: true })
    );

    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimerRef.current);
      activityEvents.forEach((event) =>
        document.removeEventListener(event, resetInactivityTimer)
      );
    };
  }, []);

  return (
    <>
      {children}

      {showSessionPopup && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/70 backdrop-blur-md px-4 animate-in fade-in duration-200">
          <div className="relative w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-2xl border border-slate-100 animate-in zoom-in-95 duration-200">
            
            {/* Ambient Background Glow */}
            <div className="absolute top-0 right-0 w-48 h-48 bg-amber-500/10 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />

            {/* Header Banner */}
            <div className="relative bg-gradient-to-br from-[#0A2540] via-[#0F3057] to-[#12345A] px-6 pt-8 pb-7 text-center text-white">
              
              {/* Security Icon Badge */}
              <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10 border border-white/20 backdrop-blur-md shadow-lg shadow-black/20">
                <ShieldAlert className="h-8 w-8 text-amber-400" />
                <span className="absolute -top-1 -right-1 flex h-4 w-4">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-amber-500 border-2 border-[#0A2540]"></span>
                </span>
              </div>

              <div className="mt-4 space-y-1">
                <div className="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-semibold bg-white/10 text-amber-200 border border-white/15 backdrop-blur-xs">
                  <Lock className="w-3 h-3 text-amber-400" /> Auto-Lock Triggered
                </div>
                <h2 className="text-xl font-bold tracking-tight text-white mt-2">
                  Session Timed Out
                </h2>
                <p className="text-xs text-blue-200/80 font-medium">
                  Terminal security inactivity protection
                </p>
              </div>
            </div>

            {/* Body Content */}
            <div className="p-6 sm:p-7 text-center space-y-6">
              <div className="bg-slate-50 border border-slate-200/80 rounded-2xl p-4 text-xs text-slate-600 space-y-1">
                <p className="font-semibold text-slate-800">
                  You have been inactive for over 30 minutes.
                </p>
                <p className="text-slate-500 leading-relaxed">
                  To protect your merchant balance and secure banking operations, please authenticate your session again.
                </p>
              </div>

              {/* Action Button */}
              <button
                onClick={handleLogout}
                className="w-full py-3.5 px-4 bg-gradient-to-r from-[#12345A] to-[#1E4D8C] hover:opacity-95 text-white text-xs font-bold rounded-xl shadow-md shadow-blue-950/20 transition-all active:scale-98 flex items-center justify-center gap-2 cursor-pointer"
              >
                <LogOut className="w-4 h-4 text-amber-400" />
                <span>Return to Partner Sign In</span>
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default SessionGuard;